module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_02_sp-c9f4cec4b62fbdbd205df9166e4a3bd8.png";